<script>
export let params = {};
import app from '../web_feathers.js';
const {perms, email, userID, checkedToken,checkingToken} = app;

import {israelPhoneMobileNormalize} from '../common_israel_mobiles.js';

import { link, location, pop, push, replace} from 'svelte-spa-router';

let error;
let myLines = [];
let loading = false;

import Fa from 'svelte-fa'
import { faCreditCard, faEdit, faMapMarkedAlt, faTools, faChevronRight, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { tick } from 'svelte';

import Swal from 'sweetalert2';
const Toast = Swal.mixin({
	toast: true,
	position: 'top-end',
	showConfirmButton: false,
	timer: 5000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.addEventListener('mouseenter', Swal.stopTimer)
		toast.addEventListener('mouseleave', Swal.resumeTimer)
		}
	});


const SimActivations = app.service('sim_activations_user');

async function init(){
	loading=true;

	var results;
	if(params.search){//copied from feathers\src\services\sim_activations\admin_sim_activations_view.svelte
		var search = params.search.replace('+',' ');//for search in omnibar it encodes space with + instead of %20
		search = decodeURIComponent(search).trim();
		if(!search) return;
		var query = [];

		if(search.match(/^x\d{4}$/)) {//exact pattern of: "x9999" is quick-search for ONLY credit card match
			query.push({TranzilaTK: {$ilike: '%'+search.replace(/[^0-9]/g,'')}});
			}
		else if(search.includes('@')) {
			query.push({email: {$ilike: '%'+search.replace('<','').replace('>','')+'%'}});
			query.push({comments_nati: {$ilike: '%'+search.replace('<','').replace('>','')+'%'}});
			}
		else {
			//multisearch multi-search
			if(search.replace(/[^0-9]/g,'').length>=4) {
				query.push({israel_number: {$ilike: '%'+search.replace(/[^0-9]/g,'').replace(/^9725/,'05')+'%'}});
				query.push({sim: {$ilike: '%'+search.replace(/[^0-9]/g,'')+'%'}});
				query.push({whatsapp: {$ilike: '%'+search.replace(/[^0-9]/g,'').split('').join('%')+'%'}});//attempt to match un-normalized format
				query.push({usa_number: {$regexp: search.replace(/[^0-9]/g,'').replace(/^1/,'').split('').join('-?')}});//we have xxx-xxx-xxxx and xxxxxxxxxx format
				query.push({comments_nati: {$ilike: '%'+search+'%'}});
				query.push({comments_billing: {$ilike: '%'+search+'%'}});
				}
			if(search.replace(/[^0-9]/g,'').length==4) {
				query.push({TranzilaTK: {$ilike: '%'+search.replace(/[^0-9]/g,'')}});
				}
			if(search.replace(/[0-9,.]/g,'').length>=3) {
				if(!search.includes('@')) query.push({email: {$ilike: '%'+search.replace('<','').replace('>','')+'%'}}); //check anyway, but not twice
				query.push({Customer_Name: {$ilike: '%'+search.replace(/[0-9,.]/g,'')+'%'}});
				query.push({comments_nati: {$ilike: '%'+search+'%'}});
				query.push({comments_billing: {$ilike: '%'+search+'%'}});
				}
			}

		results = await SimActivations.find({query:{activated:1, $or:query,$sort: {active:-1 , createdAt:1}}});
		}
	else results = await SimActivations.find({query:{activated:1,$sort: {createdAt:1}, $limit:50}});

	if(results.length==1) {
		replace('/line/'+results[0].id);
		if(params.search){//only show on searches, not for a user with only 1 account
			await tick();
			Toast.fire({
				icon: 'warning',
				title: 'Auto-loaded only result'
				});
			}
		}
	myLines = results;
	loading=false;
	}

$: (params.search||true) && init();

function status(line){
	if(line.active==false) return 'Cancelled';
	if(line.plan.startsWith('frozen')) return 'Frozen';
	else return 'Active';
	}

$: allCreditCards = myLines.map(function(s){//this is only really a problem if the person has more than one line on this email
	if(!s.TranzilaTK) return null;
	return {last4: s.TranzilaTK.slice(-4), expiry: s.cc_expiry, last_billed: s.last_billed};
	})
.sort(function(a,b){
	if(!a || !b || a.last_billed || !b.last_billed) return 0;
	if(a.last_billed>b.last_billed) return 1;
	if(a.last_billed<b.last_billed) return -1;
	return 0;
	});

$: allPhoneNumbers = myLines.filter(line=>line.active)
	.map(line=>israelPhoneMobileNormalize(line.israel_number))
	.join(', ');

</script>
<style>
.inactive td {
	background-color: #ececec;
	color: #b9b9b9;
	}

</style>
<div class="container">

<div class="row justify-content-md-center">
	<div class="d-md-none"><!-- smaller screens have a smaller font-->
		<h3>{$email} <!--Fa icon={faEdit}/--></h3>
		</div>
	<div class="d-none d-md-block"> <!-- larger screens have a bigger font-->
		<h2>{$email} <!--Fa icon={faEdit}/--></h2>
		</div>
	</div>

	{#if error}
	<div class="alert alert-danger">
	{error}
	</div>
	{/if}




<div class="row ff-dunbar title-2">
	{#if 0 && allCreditCards.length}
	<div class="col-8">
		<div class="row">
			<div class="col-4">
				Credit Card
				</div>
			<div class="col-4">
				xxxx{allCreditCards[0].last4}
				</div>
			</div>
		<div class="row">
			<div class="col-4">
				Expiry
				</div>
			<div class="col-4">
				{allCreditCards[0]?.expiry}
				</div>
			</div>
		</div>
	{/if}
	<div class="col-4">

		</div>
	</div>



<br>

<table class="table table-striped table-bordered table-hover table-sm text-center">
<thead>
	<tr>
	<th>Phone Number</th>
	<th>Status</th>
	<th>Details</th>
</tr>
</thead>
<tbody>
{#each myLines.filter(s=>s.active) as line}
<tr>
	<td>{israelPhoneMobileNormalize(line.israel_number)}</td>
	<td>
		{#if status(line)=='Frozen'}
		<span class="badge badge-warning">{status(line)}</span>
		{:else if status(line)=='Active'}
		<span class="badge badge-success">{status(line)}</span>
		{/if}

		{#if line.billing_status!='ok'}
		&nbsp;<Fa icon={faExclamationTriangle} color="#dc3545"/>
		{/if}</td>
	<td><a href="#/line/{line.id}">
		<span class="d-md-none">more...</span>
		<span class="d-none d-md-block text-left">{line.Customer_Name} <Fa icon={faChevronRight}/></span>
		</a></td>
	</tr>
	{#if 0 && line.TranzilaTK.slice(-4)!=allCreditCards[0].last4}
		 <small>different credit card: {line.TranzilaTK.slice(-4)}</small>
	{/if}
{/each}

{#if myLines.filter(s=>!s.active).length}
	<tr><td colspan=3><hr></td></tr>
{/if}

{#each myLines.filter(s=>!s.active) as line}
<tr class="inactive">
	<td>{israelPhoneMobileNormalize(line.israel_number)}</td>
	<td>{status(line)}</td>
	<td><a href="#/line/{line.id}">
		<span class="d-md-none">more...</span>
		<span class="d-none d-md-block text-left">{line.Customer_Name} <Fa icon={faChevronRight}/></span>
		</a></td>
	</tr>
{/each}
</tbody>
</table>


</div>